export const COMPANY = {
  name: "Tømrermester Andreas Guldmann ApS",
  shortName: "Andreas Guldmann",
  contactPerson: "Andreas Guldmann",
  cvr: "46300904",
  address: "Nyborgvej 512, 5881 Skårup Fyn",
  street: "Nyborgvej 512",
  postalAndCity: "5881 Skårup Fyn",
  city: "Skårup Fyn",
  phone: "61 28 71 53",
  phoneRaw: "+4561287153",
  phoneLink: "tel:+4561287153",
  email: "tmAndreasGuldmann@outlook.dk",
  emailLink: "mailto:tmAndreasGuldmann@outlook.dk",
  facebook: "https://www.facebook.com/profile.php?id=61578491407013",
  services: [
    {
      title: "Døre og vinduer",
      slug: "doere-og-vinduer",
      path: "/ydelser/doere-og-vinduer",
      icon: "fa-solid fa-door-open",
      shortDesc: "Vores absolutte hjertebarn. Vi elsker at montere og udskifte energieffektive døre og vinduer med millimeterpræcision.",
      image: "/_assets/doere-vinduer-parcelhus.jpg",
    },
    {
      title: "Træterrasser og udendørsarealer",
      slug: "traeterrasser-og-udendoersarealer",
      path: "/ydelser/traeterrasser-og-udendoersarealer",
      icon: "fa-solid fa-layer-group",
      shortDesc: "Eksklusive træterrasser, trappeløsninger og uderum skræddersyet til boligen og haven i gedigne, holdbare træsorter.",
      image: "/_assets/ny-traeterrasse-dansk-parcelhus-hero.jpg",
    },
    {
      title: "Indendørs renovering",
      subtitle: "Lofter og vægge",
      slug: "indendoers-renovering",
      path: "/ydelser/indendoers-renovering",
      icon: "fa-solid fa-hammer",
      shortDesc: "Lofter og vægge renovering. Professionel opsætning af akustiklofter, gipslofter, skillevægge og flot finish indendørs.",
      image: "/_assets/indendoers-renovering-lofter-vaegge.jpg",
    },
  ],
};
